module.exports = __webpack_public_path__ + "img/public/SiteIcons/saveCalenderClose.svg?d0ae1812";